import type ExemplarService from '../exemplar.service';
import type {Document, Department} from 'typings/portaro.be.types';

export class KpExemplarsPresenter {
    public static presenterName = 'kpExemplarsPresenter';

    /*@ngInject*/
    constructor(private exemplarService: ExemplarService) {
    }

    public async createExemplar(document: Document, department: Department) {
        await this.exemplarService.createExemplarByFormAndReload(document, department);
    }
}